import Header from "../../components/header/Header";
import Ulogin from "../../components/login/Ulogin";

const LoginPage = () => {
  return (
    <div>
      <Header />
      <Ulogin />
    </div>
  );
};
export default LoginPage;
